"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIMING_STRATEGIES = undefined;

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.incrementCounter = incrementCounter;
exports.getCounters = getCounters;
exports.clearCounters = clearCounters;
exports.measure = measure;
exports.getMeasurements = getMeasurements;
exports.clearMeasurements = clearMeasurements;
exports.resetAppStart = resetAppStart;
exports.startInteraction = startInteraction;
exports.logSegment = logSegment;
exports.endInteraction = endInteraction;
exports.resetInteractions = resetInteractions;
exports.calcElapsed = calcElapsed;
exports.getInteractions = getInteractions;
exports.debugPerformanceEvents = debugPerformanceEvents;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appStartTime = Date.now();

/*

Interaction = a bit of time we want to track. Example: Startup, Step Transition, Joining a Tutoring Session

Segment = A sub-section of an interaction. One piece that makes up the total. They don't have to add up to the total,
          and may often add up to more than the total if they happen simultaneously.

Timing Strategy = How are we going to time this Interaction? Options include:
      From Start Time - starts when we create the interaction
      From Page Start - Starts at the earliest time we know about (uses performance.now() if available, appStartTime if not)
*/

var interactions = {};
var counters = [];
var measurements = [];

var TIMING_STRATEGIES = exports.TIMING_STRATEGIES = {
  FROM_START_TIME: 0,
  FROM_PAGE_START: 1
};

function now() {
  if (window.performance && window.performance.now) {
    return Math.round(window.performance.now());
  }
  return Date.now() - appStartTime;
}

function incrementCounter(name) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  counters.push((0, _extends3.default)({
    name: name
  }, attributes));
}

function getCounters() {
  return counters.concat();
}
function clearCounters() {
  counters.splice(0);
}

function measure(name, measure1) {
  var measure2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  measurements.push((0, _extends3.default)({
    name: name,
    measure1: measure1,
    measure2: measure2
  }, attributes));
}

function getMeasurements() {
  return measurements.concat();
}
function clearMeasurements() {
  measurements.splice(0);
}

/**
 * Resets what this module considers to be the start-time of the application.
 * This only matters if performance.now isn't available, and it's done automatically,
 * so you should never have to call it outside of unit tests.
 */
function resetAppStart() {
  appStartTime = Date.now();
}

/**
 * Name must be unique.
 * @param {*} name
 */
function startInteraction(name) {
  var timingStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TIMING_STRATEGIES.FROM_START_TIME;
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  interactions[name] = (0, _extends3.default)({
    name: name,
    segments: [],
    timingStrategy: timingStrategy,
    start: timingStrategy === TIMING_STRATEGIES.FROM_PAGE_START ? 0 : now(),
    lastUpdate: now(),
    active: true
  }, attributes);
}

/**
 * Log segments when they complete. We'll consider time from the previous segment (or the start of the interaciton)
 * to this one to be part of it.
 *
 * If you pass countTime=false then the time for this segment will not be included in the overall interaction.
 * This is useful for subtracting out time waiting for the user to do something.
 *
 */
function logSegment(interactionName, segmentName) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var countTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var interaction = interactions[interactionName];

  if (interaction) {
    var previousSegment = interaction.segments[interaction.segments.length - 1];
    var lastUpdate = previousSegment ? previousSegment.lastUpdate : interaction.start;

    interaction.segments.push((0, _extends3.default)({
      countTime: countTime,
      name: segmentName,
      lastUpdate: now(),
      elapsed: now() - lastUpdate
    }, attributes));
  }
}

function endInteraction(name) {
  var interaction = interactions[name];
  if (interaction && interaction.active) {
    interaction.active = false;
    interaction.lastUpdate = now();
  }
}

function resetInteractions() {
  (0, _keys2.default)(interactions).forEach(function (name) {
    return delete interactions[name];
  });
}

function calcElapsed(interaction) {
  var overall = interaction.active ? now() - interaction.start : interaction.lastUpdate - interaction.start;
  var negativeAdjustments = interaction.segments.filter(function (segment) {
    return !segment.countTime;
  }).map(function (segment) {
    return segment.elapsed;
  }).reduce(function (acc, curr) {
    return acc + curr;
  }, 0);

  return overall - negativeAdjustments;
}

function getInteractions() {
  var clearCompleted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var rv = (0, _values2.default)(interactions).map(function (interaction) {
    return (0, _extends3.default)({}, interaction, {
      elapsed: calcElapsed(interaction)
    });
  });

  if (clearCompleted) {
    (0, _keys2.default)(interactions).filter(function (key) {
      return !interactions[key].active;
    }).forEach(function (key) {
      return delete interactions[key];
    });
  }

  return rv;
}

function debugPerformanceEvents() {
  var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  console.info("Interactions:");
  (0, _values2.default)(interactions).forEach(function (interaction) {
    var complete = interaction.active ? "RUNNING" : "COMPLETED";
    var elapsed = calcElapsed(interaction);
    console.info((label || "") + " " + interaction.name + " " + interaction.timingStrategy + " " + complete + " " + elapsed);
    interaction.segments.forEach(function (segment) {
      console.info(" - " + segment.name + " " + (segment.lastUpdate - interaction.start));
    });
  });
  console.info("Counters:");
  counters.forEach(function (counter) {
    return console.info("   ", counter);
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/eve-client/dist/performance-tracker.js
// module id = 449
// module chunks = 0